import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { Button } from '@atlassian/jira-portfolio-3-common';
import messages from './messages';

type Props = {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
};

export const LegendToggleButton = ({ isOpen, setIsOpen }: Props) => {
	const { formatMessage } = useIntl();

	const toggleLegend = useCallback(() => setIsOpen(!isOpen), [isOpen, setIsOpen]);

	const legendMessage = isOpen ? formatMessage(messages.hide) : formatMessage(messages.show);

	return (
		<Button
			onClick={toggleLegend}
			testId="portfolio-3-portfolio.app-confluence-macro.main-new.common.legend.toggle-button.toggle-button"
		>
			{legendMessage}
		</Button>
	);
};
